import { render, staticRenderFns } from "./contactItem.vue?vue&type=template&id=0695e6c6&"
import script from "./contactItem.vue?vue&type=script&lang=js&"
export * from "./contactItem.vue?vue&type=script&lang=js&"
import style0 from "./contactItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports